import {
  parseAsArrayOf,
  parseAsString,
  parseAsStringLiteral,
  useQueryState,
} from 'nuqs'
import {
  DEFAULT_SORT_BY,
  DEFAULT_SORTING_ORDERS,
  SORT_BY_KEY,
  SORT_ORDER_KEY,
  TAG_FILTER_KEY,
  TITLE_SEARCH_KEY,
} from '../../consts'
import {
  type ProjectSearchFilters,
  PROJECT_FILTERS_ORDER_BY,
  PROJECT_FILTERS_ORDER_DIRECTION,
} from '../../schemas'

export const useProjectListFilters = () => {
  const [tag_ids, setTagIds] = useQueryState(
    TAG_FILTER_KEY,
    parseAsArrayOf(parseAsString).withOptions({
      shallow: false,
    })
  )
  const [order, setOrder] = useQueryState(
    SORT_BY_KEY,
    parseAsStringLiteral(PROJECT_FILTERS_ORDER_BY)
      .withOptions({
        shallow: false,
      })
      .withDefault(DEFAULT_SORT_BY)
  )
  const [orderDirection, setOrderDirection] = useQueryState(
    SORT_ORDER_KEY,
    parseAsStringLiteral(PROJECT_FILTERS_ORDER_DIRECTION).withOptions({
      shallow: false,
    })
  )
  const [query, setQuery] = useQueryState(
    TITLE_SEARCH_KEY,
    parseAsString.withOptions({
      shallow: false,
    })
  )

  return {
    setTagIds,
    setOrder,
    setOrderDirection,
    setQuery,

    filters: {
      tag_ids: tag_ids?.length ? tag_ids : undefined,
      order: order,
      order_direction: orderDirection ?? DEFAULT_SORTING_ORDERS[order],
      query: query ?? undefined,
    } satisfies ProjectSearchFilters,
  }
}
